export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7164.dd5afbc6.jpg";